import React from "react";

const Adhd = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="48" cy="48" r="48" />
      <circle cx="47.6412" cy="47.6431" r="5.78572" fill="black" />
      <circle cx="47.644" cy="47.6425" r="19.4052" stroke="black" strokeWidth="3.6182" />
      <circle cx="47.6429" cy="47.6429" r="34.8338" stroke="black" strokeWidth="3.6182" />
    </svg>

  );
};

export default Adhd;
